var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('img',{staticStyle:{"width":"160px","height":"63px","position":"absolute","bottom":"6px","right":"30px"},attrs:{"src":require("../../assets/image/foot_logo.png")}})])
}]

export { render, staticRenderFns }